//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.TokenMode

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The model
* 
* @param clientId The client id
* @param password The password
* @param returnUrl The return url, for returning the auth-code (exchangeable for an access token)
* @param tokenMode 
* @param userName The user name
*/
@Serializable

data class TokenAuthRequest (


      /* The client id */
    @SerialName(value = "clientId") @Required val clientId: kotlin.String,


      /* The password */
    @SerialName(value = "password") @Required val password: kotlin.String,


      /* The return url, for returning the auth-code (exchangeable for an access token) */
    @SerialName(value = "returnUrl") @Required val returnUrl: kotlin.String,


      @SerialName(value = "tokenMode") @Required val tokenMode: TokenMode,


      /* The user name */
    @SerialName(value = "userName") @Required val userName: kotlin.String


) {




  }

